import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { createPortal } from 'react-dom';
import { Popper, Manager, Reference } from 'react-popper';
import clsx from 'clsx';
import { DEFAULT_MODIFIERS, propTypes, defaultProps, VARIANT_MAP } from './Tooltip.types.js';
import styles from './Tooltip.module.scss.js';

var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFocused: false,
            tooltipVisible: false,
        };
        _this.updateVisible = function () {
            return _this.setState(function (_a) {
                var isFocused = _a.isFocused;
                return ({ tooltipVisible: isFocused });
            }, _this.popperScheduleUpdate);
        };
        _this.setVisible = function () {
            var delayShow = _this.props.delayShow;
            if (delayShow) {
                _this.showTimeoutId = window.setTimeout(_this.updateVisible, delayShow);
            }
            else {
                _this.updateVisible();
            }
        };
        _this.setHidden = function () {
            var delayHide = _this.props.delayHide;
            if (delayHide) {
                _this.hideTimeoutId = window.setTimeout(function () { return _this.setState({ tooltipVisible: false }); }, delayHide);
            }
            else {
                _this.setState({ tooltipVisible: false });
            }
        };
        _this.setFocused = function () {
            return _this.setState({ isFocused: true }, _this.setVisible);
        };
        _this.setUnfocused = function () {
            return _this.setState({ isFocused: false }, _this.setHidden);
        };
        _this.renderTooltipContent = function () {
            var _a;
            var _b = _this.props, variant = _b.variant, tooltipClassName = _b.tooltipClassName, tooltipContent = _b.tooltipContent, disabled = _b.disabled, hideArrow = _b.hideArrow;
            var tooltipVisible = _this.state.tooltipVisible;
            var placementName = VARIANT_MAP[variant];
            var tooltipClasses = clsx(styles.TooltipContent, tooltipClassName, (_a = {},
                _a[styles.TooltipContent___visible] = !disabled && tooltipVisible,
                _a));
            return (React__default.createElement(Popper, { placement: placementName, modifiers: DEFAULT_MODIFIERS }, function (popperParams) {
                var placement = popperParams.placement, ref = popperParams.ref, style = popperParams.style, arrowProps = popperParams.arrowProps, scheduleUpdate = popperParams.scheduleUpdate;
                _this.popperScheduleUpdate = scheduleUpdate;
                return (React__default.createElement("div", { ref: ref, style: style, "data-placement": "" + placement, "data-variant": variant, className: tooltipClasses, "data-testid": _this.props['data-testid'] },
                    tooltipContent,
                    !hideArrow && (React__default.createElement("div", { ref: arrowProps.ref, "data-placement": placement, className: styles.Arrow, "data-testid": _this.props['data-testid'] + "-arrow" }))));
            }));
        };
        return _this;
    }
    Tooltip.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.showTimeoutId);
        window.clearTimeout(this.hideTimeoutId);
    };
    Tooltip.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, portalTarget = _a.portalTarget;
        return (React__default.createElement(Manager, null,
            React__default.createElement(Reference, null, function (_a) {
                var ref = _a.ref;
                return (React__default.createElement("div", { ref: ref, onMouseEnter: _this.setFocused, onMouseLeave: _this.setUnfocused, className: clsx(styles.Tooltip, className), "data-testid": _this.props['data-testid'] + "-wrapper" }, children));
            }),
            portalTarget
                ? createPortal(this.renderTooltipContent(), portalTarget)
                : this.renderTooltipContent()));
    };
    Tooltip.displayName = 'Tooltip';
    Tooltip.propTypes = propTypes;
    Tooltip.defaultProps = __assign({}, defaultProps);
    return Tooltip;
}(React__default.Component));

export { Tooltip as default };
